import { useMutation, useQueryClient } from '@tanstack/react-query';
import { generateGroupInfoQueryOptions } from '@/hooks/groups/use-group-info';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useTransferGroup(groupId: Nullable<number>) {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, number>({
    mutationKey: ['/TransGroup', groupId],
    mutationFn: (params) =>
      fetcher(
        '/TransGroup',
        {
          GroupID: groupId,
          UserID: params,
        },
        { validResponseCodes: [0] },
      ),
    onSuccess: () => queryClient.invalidateQueries(generateGroupInfoQueryOptions(groupId)),
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}
